import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const DynamicDashboard = lazy(()=> import(/* webpackChunkName: "DynamicDashboard" */'./components'));

const routes = () => <PrivateRoute exact path="/dynamic-dashboard" component={DynamicDashboard} />;

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/dynamicDashboard/DynamicDashboard/routes.js